import { Component } from '@angular/core';

import { inOutAnimation } from '../animations/in-out.animation';
import { BasePageComponent } from '../../shared/components/base-page.component';
import { AuthenticationManager } from '../../shared/services/authentication-manager';
import { NavigationService } from '../../shared/services/navigation.service';
import { LocalizerService, ScreenService } from '../../shared';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  animations: [inOutAnimation]
})
export class LoginComponent extends BasePageComponent {

  username: string = this.auth.currentSignUpUserEmail ?? "";
  password: string = "";

  passwordFieldMode: "password" | "text" = "password";
  passwordButtonOptions = {
    icon: 'eyeopen',
    stylingMode: 'text',
    onClick: () => {
      this.passwordFieldMode = this.passwordFieldMode === "password" ? "text" : "password";
    },
  };

  readonly returnUrl: string | null = null;
  readonly isInvitationContext: boolean;

  constructor(private auth: AuthenticationManager,
    private navigation: NavigationService,
    private route: ActivatedRoute,
    private router: Router,
    localizer: LocalizerService,
    screen: ScreenService) {
    super(screen, localizer);
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    this.isInvitationContext = this.returnUrl ? this.returnUrl.includes('invitation_code=') : false;
  }

  login() {
    if (this.isBusy) {
      return;
    }

    this.isBusy = true;
    this.auth.login(this.username, this.password).subscribe({
      next: this.loginCompleted.bind(this),
      error: this.loginFailed.bind(this)
    });
  }

  navigateToSignup() {
    this.navigation.navigateToSignup(this.returnUrl ?? undefined);
  }

  navigateToResetPassword() {
    this.navigation.navigateToResetPassword(this.returnUrl ?? undefined);
  }

  private loginCompleted(success: boolean) {
    this.isBusy = false;
    if (success) {
      if (this.returnUrl) {
        this.router.navigateByUrl(this.returnUrl);
      } else {
        this.navigation.navigateToInstallationsList();
      }
    } else {
      this.displayError();
    }
  }

  private loginFailed(error: any) {
    console.log(error);
    this.isBusy = false;
    const message = (typeof error === "string") ? error : null;
    this.displayError(message);
  }

}
